import { render } from "./FilterLubrificantes.vue?vue&type=template&id=6cc49a4e&scoped=true&ts=true"
import script from "./FilterLubrificantes.vue?vue&type=script&lang=ts"
export * from "./FilterLubrificantes.vue?vue&type=script&lang=ts"

import "./FilterLubrificantes.vue?vue&type=style&index=0&id=6cc49a4e&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc49a4e"]])

export default __exports__